import FileMetaDTO from "@/dto/files/FileMetaDTO";

export default class AddPRILAdditionalFilePayload {
  file: FileMetaDTO | null = null;
  comment = "";
}